module.exports = __webpack_public_path__ + "assets/japan.320c38768da611b85e59084f0a059800.svg?";